import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_2_2 from '../../assets/press/Press-2-2.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_4 from '../../assets/press/Press-5-1.jpg';

export default function PressPage2() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_1,
      title:
        'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
      link: ROUTE_NAMES.PRESS1,
    },
    {
      image: P_3,
      title:
        'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
      link: ROUTE_NAMES.PRESS3,
    },
    {
      image: P_4,
      title:
        'The Future of Luxury Real Estate: An Exclusive Interview with Gevorg Shahbazyan, Visionary Founder of Starlife Group',
      link: ROUTE_NAMES.PRESS4,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: 21 Hollywood, a new 13-story mixed-use apartment development
          is coming to the heart of Hollywood
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_2} alt='press-image' />
        <h2 className='press-page-title'>
          21 Hollywood, a new 13-story mixed-use apartment development is coming
          to the heart of Hollywood
        </h2>
        <span className='author-name'>By Jake Nicholas</span>
        <span className='author-name'>Dec 7, 2023</span>
        <Link
          to={
            'https://www.oftmw.com/post/21-hollywood-a-new-13-story-mixed-use-apartment-development-is-coming-to-the-heart-of-hollywood'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p>
            21 Hollywood represents a fusion of luxury and modern living in the
            heart of Hollywood. This mixed-use development, developed by
            Starlife Group and crafted by the renowned architect Kobi Karp,
            encompasses over 200 upscale units, including 18 penthouse suites
            with terraces, spread across a 1.5-acre property. The project also
            integrates 10,000 square feet of retail and commercial space,
            catering to a range of business and entrepreneurial needs.
          </p>
          <p>
            21 Hollywood represents a fusion of luxury and modern living in the
            heart of Hollywood. This mixed-use development, developed by
            Starlife Group and crafted by the renowned architect Kobi Karp,
            encompasses over 200 upscale units, including 18 penthouse suites
            with terraces, spread across a 1.5-acre property. The project also
            integrates 10,000 square feet of retail and commercial space,
            catering to a range of business and entrepreneurial needs.
          </p>
          <img src={P_2_2} alt='press-image' />
          <p>
            For family-oriented activities, there is a children's playground, an
            outdoor garden, and a courtyard. The development also features a
            game room, jacuzzi, summer kitchen, and cabanas, enhancing the
            communal and recreational experience.
          </p>
          <p>
            Special attention is given to pet-friendly amenities, with a
            dedicated pet spa, and to social and relaxation spaces, including
            rooftop terraces with an outdoor media/lounge area. Positioned near
            Hollywood Beach, Downtown Hollywood, Dania Pointe, and the airport,
            21 Hollywood is conveniently located amidst a vibrant dining and
            cultural scene.
          </p>
          <p>
            21 Hollywood construction commencement is planned to begin Summer of
            2024, with expected delivery in early 2026.
          </p>
          <iframe
            title='Google Map Location'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.099510641962!2d-80.1462619250823!3d26.03029989745509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abaa6d3f33b9%3A0xc2c60b28d83d4594!2zMjEwMCBOIEZlZGVyYWwgSHd5LCBIb2xseXdvb2QsIEZMIDMzMDIwLCDQodCo0JA!5e0!3m2!1sru!2sam!4v1747902513561!5m2!1sru!2sam'
            width='100%'
            height='400'
            style={{ border: 0 }}
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
